<template>
  <b-modal ref="error-login-modal" modal-class="error-login-modal" size="lg" centered hide-footer>
    <div class="error-login-container">
      <div class="error-login-content">
        <h3>{{error.heading}}</h3>
        <div class="error-login-text" v-html="error.text"></div>
      </div>
      <div class="error-login-icon">
        <img :src="this.getSrc(error.img)" alt="">
      </div>
    </div>
    <div class="error-login-btn">
      <b-button @click="closeModal()">{{error.btnText}}</b-button>
    </div>
  </b-modal>
</template>

<script>
import imageMixin from '@/mixins/image'
export default {
  name: 'LoginErrorModal',
  props: ['error'],
  mixins: [imageMixin],
  mounted() {
    this.$refs['error-login-modal'].show()
  },
  methods: {
    closeModal: function ()
    {
      this.$refs['error-login-modal'].hide()
    }
  }
}
</script>
<style lang="scss" scoped>
  h3 {
    margin-bottom: 24px;
    font-size: 36px;
    font-weight: 600;
    color: #000;
  }
  .error-login-text {
    color: #636363;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 15px;
  }
  .error-login-container {
    display: flex;
    flex-direction: column;
    .error-login-content {
      order: 1;
    }
    .error-login-icon {
      order: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: -32px;
      margin-bottom: 32px;
      img {
        width: 45px;
      }
    }
  }
  @media only screen and (min-width: 768px) {
    .error-login-container {
      flex-direction: row;
      .error-login-content {
        order: 0;
        flex: 1 0 300px;
        margin-right: 32px;
      }
      .error-login-icon {
        order: 1;
        flex: 0 0 240px;
        margin: 0;
        img {
          width: auto;
        }
      }
    }
  }
</style>
<style lang="scss">
  .error-login-modal {
    .modal-content {
      border-top: 10px solid #30A7FE;
      border-bottom: 10px solid #30A7FE;
    }
    .modal-header {
      border-bottom: 0;
    }
  }
  @media only screen and (min-width: 768px) {
    .error-login-modal {
      .modal-body {
        padding: 12px 12px 32px 54px;
      }
    }
  }
  @media only screen and (min-width: 768px) and (max-width: 992px) {
    .error-login-modal {
      .modal-dialog {
        max-width: 700px;
      }
    }
  }
  .error-login-btn{
    width: 100%;
    display: block;
    text-align: center;

    button{
      background: white;
      border: 1px solid #EDEFF2;
      color: black;
      margin-right: 25px;
      border-radius: 10px;
    }
  }
  .error-login-content {
    .text-larger {
      display: inline-block;
      margin-bottom: 5px;
      font-size: 18px;
      font-weight: 500;
    }
  }
</style>
